export enum Permission {
  CREATE_USER = 'CREATE_USER',
  EDIT_USER = 'EDIT_USER',
  DELETE_USER = 'DELETE_USER',
  VIEW_USER = 'VIEW_USER',

  CREATE_GROUP = 'CREATE_GROUP',
  EDIT_GROUP = 'EDIT_GROUP',
  DELETE_GROUP = 'DELETE_GROUP',
  VIEW_GROUP = 'VIEW_GROUP',

  CREATE_RELATION = 'CREATE_RELATION',
  EDIT_RELATION = 'EDIT_RELATION',
  DELETE_RELATION = 'DELETE_RELATION',
  VIEW_RELATION = 'VIEW_RELATION',

  EMPLOYEE_CREATE = 'EMPLOYEE_CREATE',
  EMPLOYEE_VIEW = 'EMPLOYEE_VIEW',
  EMPLOYEE_UPDATE = 'EMPLOYEE_UPDATE',
  EMPLOYEE_DELETE = 'EMPLOYEE_DELETE',

  STORE_CREATE = 'STORE_CREATE',
  STORE_VIEW = 'STORE_VIEW',
  STORE_UPDATE = 'STORE_UPDATE',
  STORE_DELETE = 'STORE_DELETE',

  SHIFT_CREATE = 'SHIFT_CREATE',
  SHIFT_VIEW = 'SHIFT_VIEW',
  SHIFT_UPDATE = 'SHIFT_UPDATE',
  SHIFT_DELETE = 'SHIFT_DELETE',

  PAYROLL_CREATE = 'PAYROLL_CREATE',
  PAYROLL_VIEW = 'PAYROLL_VIEW',
  PAYROLL_UPDATE = 'PAYROLL_UPDATE',
  PAYROLL_DELETE = 'PAYROLL_DELETE',

  RATE_CREATE = 'RATE_CREATE',
  RATE_VIEW = 'RATE_VIEW',
  RATE_UPDATE = 'RATE_UPDATE',
  RATE_DELETE = 'RATE_DELETE',

  ATTENDANCE_REPORT_CREATE = 'ATTENDANCE_REPORT_CREATE',
  ATTENDANCE_REPORT_VIEW = 'ATTENDANCE_REPORT_VIEW',
  ATTENDANCE_REPORT_UPDATE = 'ATTENDANCE_REPORT_UPDATE',
  ATTENDANCE_REPORT_DELETE = 'ATTENDANCE_REPORT_DELETE',

  COMPANY_CREATE = 'COMPANY_CREATE',
  COMPANY_VIEW = 'COMPANY_VIEW',
  COMPANY_UPDATE = 'COMPANY_UPDATE',
  COMPANY_DELETE = 'COMPANY_DELETE',

  TICKET_CREATE = 'TICKET_CREATE',
  TICKET_VIEW = 'TICKET_VIEW',
  TICKET_UPDATE = 'TICKET_UPDATE',
  TICKET_DELETE = 'TICKET_DELETE',

  TICKET_TRANSACTION_CREATE = 'TICKET_TRANSACTION_CREATE',
  TICKET_TRANSACTION_VIEW = 'TICKET_TRANSACTION_VIEW',
  TICKET_TRANSACTION_UPDATE = 'TICKET_TRANSACTION_UPDATE',
  TICKET_TRANSACTION_DELETE = 'TICKET_TRANSACTION_DELETE',

  TICKET_CATEGORY_VIEW = 'TICKET_CATEGORY_VIEW',
  TICKET_CATEGORY_CREATE = 'TICKET_CATEGORY_CREATE',
  TICKET_CATEGORY_EDIT = 'TICKET_CATEGORY_EDIT',
  TICKET_CATEGORY_DELETE = 'TICKET_CATEGORY_DELETE',

  TRANSACTION_CREATE = 'TRANSACTION_CREATE',
  TRANSACTION_VIEW = 'TRANSACTION_VIEW',
  TRANSACTION_UPDATE = 'TRANSACTION_UPDATE',
  TRANSACTION_DELETE = 'TRANSACTION_DELETE',

  CASH_REGISTER_CREATE = 'CASH_REGISTER_CREATE',
  CASH_REGISTER_VIEW = 'CASH_REGISTER_VIEW',
  CASH_REGISTER_UPDATE = 'CASH_REGISTER_UPDATE',
  CASH_REGISTER_DELETE = 'CASH_REGISTER_DELETE',

  NOTIFICATION_VIEW = 'NOTIFICATION_VIEW',
}
